export const FILTER_SHADOW_ELEVATION_CLASSES = {
    low: 'drop-shadow-low',
    medium: 'drop-shadow-medium',
    high: 'drop-shadow-high',
};
export const BOX_SHADOW_ELEVATION_CLASSES = {
    low: 'shadow-low',
    medium: 'shadow-medium',
    high: 'shadow-high',
};
